export const SET_GIG_MODE = "SET_GIG_MODE";
export const SET_GIG_LISTING_DATA = "SET_LISTING_DATA";
export const SET_GIG_LISTING_SUBSCRIPTION = "SET_GIG_LISTING_SUBSCRIPTION";
export const SET_SHOW_GIG_BOOKING_FLOW = "SET_SHOW_GIG_BOOKING_FLOW";
export const SET_SELECTED_SLOT = "SET_SELECTED_SLOT";
export const SET_FETCHING_SUBSCRIPTION_DATA = "SET_FETCHING_SUBSCRIPTION_DATA";
